enum PhaseDurationUnit {
    Day = "day",
    Week = "week",
    Hours = "hours"
}

const DURATION_OPTIONS = [
    {
        id: PhaseDurationUnit.Day,
        name: "Day"
    },
    {
        id: PhaseDurationUnit.Week,
        name: "Week"
    },
    {
        id: PhaseDurationUnit.Hours,
        name: "Hours"
    }
]

type ProgramVersionPhaseTemplateDetail = {
    phaseId: number
    phaseName: number
    programVersionPhaseShiftTemplateId: number
    shifts: any[]
    durationUnit: PhaseDurationUnit
    duration: number
    position: number
}

export {PhaseDurationUnit, DURATION_OPTIONS}
export type {ProgramVersionPhaseTemplateDetail}
